// Angular
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, Output, EventEmitter, DoCheck } from '@angular/core';
// Layout
import { LayoutConfigService } from '../../../../../core/_base/layout';
import { LEFT_ARROW } from '@angular/cdk/keycodes';
// Charts
// import { Chart } from 'chart.js/dist/Chart.min.js';

@Component({
	selector: 'kt-widget14',
	templateUrl: './widget14.component.html',
	styleUrls: ['./widget14.component.scss'],
})
export class Widget14Component implements OnInit, OnChanges, DoCheck {
	// Public properties
	@Output() messageEvent = new EventEmitter<string>();
	@Input() title: string;
	@Input() desc: string;
	@Input() data: { labels: string[], datasets: any[], options : {} };
	@Input() type = 'bar';
	@ViewChild('chart', {static: true}) chart: ElementRef;
	chartData: any; 

	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 */
	constructor(private layoutConfigService: LayoutConfigService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.chartData = new Chart(this.chart.nativeElement, {});
		if (!this.data) {
			this.data = {
				labels: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7', 'Day 8', 'Day 9', 'Day 10', 'Day 11', 'Day 12', 'Day 13', 'Day 14', 'Day 15', 'Day 16'],
				datasets: [
					{
						// label: 'dataset 1',
						backgroundColor: this.layoutConfigService.getConfig('colors.state.success'),
						data: [
							15, 20, 25, 30, 25, 20, 15, 20, 25, 30, 25, 20, 15, 10, 15, 20
						]
					}, {
						// label: 'dataset 2',
						backgroundColor: '#f3f3fb',
						data: [
							15, 20, 25, 30, 25, 20, 15, 20, 25, 30, 25, 20, 15, 10, 15, 20
						]
					}
				],
				options: {
					title: {
						display: false,
					},
					tooltips: {
						intersect: false,
						mode: 'nearest',
						xPadding: 10,
						yPadding: 10,
						caretPadding: 10
					},
					legend: {
						display: true,
						positiom: 'top',
						align:'end',
						labels: {
							fontColor: 'rgb(255, 99, 132)'
						}
					},
					// onClick: this.newChartClick,
					responsive: true,
					maintainAspectRatio: false,
					barRadius: 4,
					scales: {
						xAxes: [{
							display: true,
							gridLines: true,
							stacked: true,
						}],
						yAxes: [{
							display: true,
							stacked: true,
							gridLines: true,
							ticks: {
								// max: this.data.maximumValue + 10,
								// stepSize: this.data.maximumValue/10,
								display: true,
								beginAtZero: true,
								fontColor: this.layoutConfigService.getConfig('colors.base.shape.3'),
								fontSize: 13,
								padding: 10
							}
						}]
					},
					layout: {
						padding: {
							left: 5,
							right: 5,
							top: 0,
							bottom: 0
						}
					}
				}
			};
		}
		if(!(this.data.options)){
			this.data.options= {
				title: {
					display: false,
				},
				tooltips: {
					intersect: false,
					mode: 'nearest',
					xPadding: 10,
					yPadding: 10,
					caretPadding: 10
				},
				legend: {
					display: true,
					position: 'top',
					align:'end',
					labels: {
						fontColor: 'rgb(255, 99, 132)'
					}
				},
				// onClick: this.newChartClick,
				responsive: true,
				maintainAspectRatio: false,
				barRadius: 4,
				scales: {
					xAxes: [{
						display: true,
						gridLines: true,
						stacked: true,
						ticks: {
							padding: 10
						  }
					}],
					yAxes: [{
						display: false,
						stacked: true,
						ticks: {
							// max: this.data.maximumValue + 10,
							// stepSize: this.data.maximumValue/10,
							display: true,
							beginAtZero: true,
							fontColor: this.layoutConfigService.getConfig('colors.base.shape.3'),
							fontSize: 13,
							padding: 10
						}
					}]
				},
				layout: {
					padding: {
						left: 5,
						right: 5,
						top: 0,
						bottom: 0
					}
				},

			}
		}
		// this.initChart();
	}
	ngOnChanges(){
		setTimeout(() => {
		this.initChart();
		}, 2500);
		
	}
	ngDoCheck() {
		setTimeout(() => {
			// this.initChart()
		this.chartData.update()
		}, 2500);
	  }
	/** Init chart */
	private initChart() {
		// For more information about the chartjs, visit this link
		// https://www.chartjs.org/docs/latest/getting-started/usage.html

		this.chartData = new Chart(this.chart.nativeElement, {
			type: 'bar',
			data: this.data,
			options:this.data.options,
			plugins: [{
                beforeInit: function(chart, options) {
                  chart.legend.afterFit = function() {
                    this.height = this.height + 30;
                  };
                }
              }]
		});
		this.chart.nativeElement.onclick = (event: any) => {
			var activePoints = this.chartData.getElementAtEvent(event);
			var firstPoint = activePoints[0];
			var label = this.chartData.data.labels[firstPoint._index];
			if (firstPoint !== undefined)
			this.messageEvent.emit(label)
			}
			
	}
}
